import api from "@/api";

export default {
  state: {
    teams: []
  },
  getters: {
    teams: (state) => state.teams,
  },
  mutations: {
    setTeams: (state, data) => {
      state.teams = data;
    },

  },
  actions: {
    getTeams: async ({ commit }) => {
      try {
        const response = await api({ requiresAuth: true }).get("/v1/teams");
        const { data } = response.data;
        commit("setTeams", data);
      } catch (err) {
        console.error(err);
      }
    },

    getTeamAgents: async (_, id) => {
      try {
        const response = await api({ requiresAuth: true }).get(`/v1/teams/${id}/agents`);
        const { data } = response.data;
        return data;
      } catch (err) {
        console.error("Error fetching team agents:", err);
        return [];
      }
    },


    deleteTeam: async ({ commit, dispatch }, teamId) => {
      commit("setUsersLoading", true);
      try {
        await api({ requiresAuth: true }).delete(`/v1/teams/${teamId}`);
        await dispatch("getTeams");

      } catch (err) {
        console.error(err);
      }
      commit("setTeamsLoading", false);
    },
    createTeam: (
      { commit, dispatch },
      {
        name,
        fromTeamId,
        owner,
        finma_nr,
        mandate_type_ids,
        zip,
        city,
        street,
        number,
        file

      }
    ) =>
      new Promise((resolve, reject) => {
        const payload = {
          name: name,
          fromTeamId,
          owner_id: owner.id,
          finma_nr: finma_nr,
          zip,
          city,
          street,
          number,
          file
        };

        // Include mandate_type_ids if provided
        if (mandate_type_ids !== undefined) {
          payload.mandate_type_ids = mandate_type_ids;
        }

        api({ requiresAuth: true })
          .post("/v1/teams", payload)
          .then(
            async (response) => {
              const { data } = response.data;
              commit("setTeamsLoading", true);
              await dispatch("getTeams");
              resolve(data);
              commit("setTeamsLoading", false);

              if (file) {
                await dispatch("addTeamPhoto", {
                  teamId: data.id,
                  file,
                });
              }
            },
            (err) => {
              commit("setTeamsLoading", false);
              reject(err);
            }
          );
      }),
    updateTeam: (
      { commit, dispatch },
      {
        teamId,
        name,
        owner,
        finma_nr,
        mandate_type_ids,
        street,
        number,
        zip,
        city

      }
    ) =>
      new Promise((resolve, reject) => {
        const payload = {
          name: name,
          owner_id: owner.id,
          finma_nr: finma_nr,
          teamId: teamId,
          street,
          number,
          city,
          zip
        };

        // Include mandate_type_ids if provided
        if (mandate_type_ids !== undefined) {
          payload.mandate_type_ids = mandate_type_ids;
        }

        api({ requiresAuth: true })
          .patch("/v1/teams/" + teamId, payload)
          .then(
            async (response) => {


              const { data } = response.data;
              commit("setTeamsLoading", true);
              await dispatch("getTeams");
              resolve(data);
              commit("setTeamsLoading", false);
            },
            (err) => {
              commit("setTeamsLoading", false);
              reject(err);
            }
          );
      }),
    addTeamPhoto: async (_, { teamId, file }) => {
      const formData = new FormData();
      formData.append("photo", file);
      return api({ requiresAuth: true }).post(
        `/v1/teams/${teamId}/files`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    },
  },


};
